import { FC } from 'react';
import { CalculatorHeading } from '@components/common/CalculatorHeading/CalculatorHeading';
import { CalculatorText } from '@components/common/CalculatorText/CalculatorText';
import { CalculatorFormControlProps } from './types';
import { FormControl } from '@components/common/FormControl/FormControl';
export const CalculatorFormControl: FC<CalculatorFormControlProps> = ({
  name,
  textKey,
  titleKey,
  rules,
  className,
  radioOptions,
  isWide,
}) => {
  return (
    <div className={className}>
      <CalculatorHeading labelKey={titleKey} />
      {textKey && <CalculatorText labelKey={textKey} />}
      <FormControl isWide={isWide} name={name} className={'mt-2'} radioOptions={radioOptions} rules={rules} />
    </div>
  );
};
